
<div class="Section Features" id="features">
    <h2>Wir <span>vereinfachen</span> alle Ihre Aufgaben</h2>
    <div class="Content">
        <div class="Feature">
            <div class="Text">
                <h3>Die Taxisoftware von morgen</h3>
                <div class="VideoWrap">
                    <video
                        class="Video"
                        muted
                        controls
                        playsinline
                        ref="featureVideo"
                        poster="/product/tf-demo-poster.jpg"
                        preload="none"
                    >
                        <source data-src="/product/tf-demo.mp4" type="video/mp4" />
                    </video>
                    <div class="VideoOverlay" v-if="!videoLoaded" @click="loadVideo">
                        <div class="PlayButton">
                            <i class="ri-play-fill"></i>
                        </div>
                        <div class="OverlayText">Video abspielen</div>
                    </div>
                </div>

                <p>
                    Umfassende Managementlösung, die speziell für die Anforderungen und Abläufe
                    von Taxiunternehmen entwickelt wurde. Durch die intuitive Benutzeroberfläche
                    und leistungsfähige Analysewerkzeuge können Sie Ihren Betrieb effizienter
                    und transparenter gestalten.
                    <br /><br />
                    Die Plattform integriert alle notwendigen Funktionen, von der
                    Fahrzeugverfolgung bis hin zur Umsatzanalyse, in einem einzigen, leicht
                    zugänglichen System.
                </p>
            </div>
        </div>

        <h2 class="Features-Title">Auf einem <span>Blick</span></h2>
        <div class="Features-Grid">
            <div class="Feature-Item">
                <i class="ri-focus-line"></i>
                <h3>Übersicht über Ihr Unternehmen</h3>
                <p>
                    Erhalten Sie detaillierte Einblicke und Analysen über Ihr Unternehmen, um
                    fundierte Entscheidungen zu treffen.
                </p>
            </div>

            <div class="Feature-Item">
                <i class="ri-smartphone-line"></i>
                <h3>Integrierte Fahrer-App</h3>
                <p>
                    Ermöglichen Sie Ihren Fahrern den Zugriff auf Fahrtdaten und Optimierung der
                    Routen direkt über ihr Smartphone.
                </p>
            </div>

            <div class="Feature-Item">
                <i class="ri-cloud-line"></i>
                <h3>Internetbasierte Verwaltung</h3>
                <p>
                    Verwalten Sie Ihr Geschäft von überall aus mit einer Cloud-Plattform, die
                    Ihnen maximale Flexibilität bietet.
                </p>
            </div>

            <div class="Feature-Item">
                <i class="ri-shield-check-line"></i>
                <h3>Erfüllung gesetzlicher Anforderungen</h3>
                <p>
                    Bleiben Sie immer auf dem neuesten Stand der gesetzlichen Bestimmungen und
                    vermeiden Sie rechtliche Probleme.
                </p>
            </div>
            <div class="Feature-Item">
                <i class="ri-brain-line"></i>
                <h3>Über 30 Jahre Erfahrung</h3>
                <p>
                    Das System wurde mit direktem Input und Erfahrungen von Taxi- und
                    Mietwagenunternehmern und -fahrern entwickelt, um sicherzustellen, dass es
                    den Bedürfnissen der Kunden entspricht.
                </p>
            </div>

            <div class="Feature-Item">
                <i class="ri-pie-chart-line"></i>
                <h3>Advanced Analyse</h3>
                <p>
                    Greifen Sie auf fortgeschrittene Analysetools zu, um die Leistung Ihres
                    Unternehmens genau zu verstehen und zu verbessern.
                </p>
            </div>
        </div>

        <div class="LearnMore-Section">
            <div class="Container">
                <div class="LearnMore-Content">
                    <h3>Entdecken Sie alle Details</h3>
                    <p>
                        Erfahren Sie mehr über unsere umfassenden Funktionen und wie TaxiFusion
                        Ihr Taxiunternehmen noch effizienter machen kann.
                    </p>
                    <router-link to="/features">
                        <SiteButton>
                            Alle Features entdecken
                            <i class="ri-arrow-right-line" style="margin-left: 8px"></i>
                        </SiteButton>
                    </router-link>
                </div>
            </div>
        </div>

        <div class="Feature Feature--App">
            <div class="Text">
                <h3>Die App für den Fahrer</h3>
                <p>
                    Die Fahrer-App ermöglicht es den Fahrern, auf wichtige Informationen
                    zuzugreifen und ihre Fahrten effizient zu verwalten. Mit
                    Echtzeit-Statistiken und Zugriff auf Betriebsdaten können Fahrer ihre
                    Leistung verbessern. Die App ist benutzerfreundlich gestaltet und bietet den
                    Fahrern eine nahtlose Integration in das Gesamtsystem.
                </p>

                <div class="AppStoreIcons">
                    <a
                        href="https://apps.apple.com/de/app/taxifusion-driver-app/id6523420111?l=en-GB"
                        target="_blank"
                        ref="noopener noreferrer"
                    >
                        <img
                            src="/app-store-icon.png"
                            alt="TaxiFusion Fahrer-App im Apple App Store herunterladen - iOS Version verfügbar"
                            height="50"
                            width="169"
                            style="border: 0.5px solid white; border-radius: 10px"
                            loading="lazy"
                        />
                    </a>
                    <a
                        href="https://play.google.com/store/apps/details?id=com.taxifusion.driverApp"
                        target="_blank"
                        ref="noopener noreferrer"
                    >
                        <img
                            src="/google-play-icon.png"
                            alt="TaxiFusion Fahrer-App im Google Play Store herunterladen - Android Version verfügbar"
                            height="50"
                            width="168"
                            loading="lazy"
                            style="border: 0.5px solid white; border-radius: 10px"
                        />
                    </a>
                </div>
            </div>
            <div class="AppMockup">
                <picture class="AppMockup-Desktop">
                    <source
                        srcset="/product/mobile-app-desktop-transparent.webp"
                        type="image/webp"
                    />
                    <source
                        srcset="/product/mobile-app-desktop-transparent.png"
                        type="image/png"
                    />
                    <img
                        src="/product/mobile-app-deskop.png"
                        alt="TaxiFusion Mobile App - Moderne und einfache Bedienung für Taxifahrer"
                        width="1200"
                        height="772"
                        loading="lazy"
                        decoding="async"
                    />
                </picture>
                <picture class="AppMockup-Mobile">
                    <source
                        srcset="/product/mobile-app-mobile-transparent.webp"
                        type="image/webp"
                    />
                    <source
                        srcset="/product/mobile-app-mobile-transparent.png"
                        type="image/png"
                    />
                    <img
                        src="/product/mobile-app-mobile.png"
                        alt="TaxiFusion Mobile App - MyPOS integriert für nahtlose Zahlungsabwicklung"
                        width="800"
                        height="854"
                        loading="lazy"
                        decoding="async"
                    />
                </picture>
            </div>
        </div>
    </div>
</div>
